import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import AuthService from "services/auth-service";
import bgImage from "assets/images/bg-sign-up-cover.jpeg";

const VerifyEmail = () => {
  const [token, setToken] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const tokenFromURL = queryParams.get("token");
    if (tokenFromURL) {
      setToken(tokenFromURL);
      verifyEmail(tokenFromURL);
    } else {
      setError("Invalid verification link.");
      setLoading(false);
    }
  }, []);

  const verifyEmail = async (token) => {
    try {

      const payload = {
        data: {
          type: "verify-email",
          attributes: {
            token: token,
          },
        },
      };

      const response = await AuthService.verifyEmail(payload);
      setMessage(response.message);
    } catch (err) {
      setError(err.response?.data?.message || "Verification failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h3" fontWeight="medium" color="white" mt={1}>
            Email Verification
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3} textAlign="center">
          {loading && <MDTypography variant="body1">Verifying your email...</MDTypography>}
          {message && (
            <MDBox display="flex" justifyContent="center">
              <MDAlert color="success" sx={{ fontSize: "0.875rem", p: 1, my: 1, textAlign: "center", maxWidth: "400px" }}>
                {message}
              </MDAlert>
            </MDBox>
          )}
          {error && (
            <MDBox display="flex" justifyContent="center">
              <MDAlert color="error" sx={{ fontSize: "0.875rem", p: 1, my: 1, textAlign: "center", maxWidth: "400px" }}>
                {error}
              </MDAlert>
            </MDBox>
          )}

                    
          {message && (
            <MDBox mt={3}>
              <MDButton
                variant="contained"
                color="accent"
                fullWidth
                onClick={() => navigate("/auth/login")}
              >
                Login
              </MDButton>
            </MDBox>
          )}
        </MDBox>
      </Card>
    </CoverLayout>
  );
};

export default VerifyEmail;
